module.exports = __webpack_public_path__ + "static/media/blue-template-big.4868e707.png";